export default {
    name: 'Confirmation',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '800px'
        },
        height: {
            type: String,
            default: 'auto'
        },
        typeConfirmation: {
            type: String,
            default: ''
        },
        textConfirmation: {
            type: String,
            default: ''
        },
        multipleContacts: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        confirmationPositive() {
            if (this.multipleContacts) {
                this.$emit('confirmationPositiveMultiple', this.typeConfirmation);
            } else {
                this.$emit('confirmationPositive', this.typeConfirmation);
            }
        }
    }
};
